<template>
  <section class="ui-card ss-card">
    <div class="ss-card__b">
      <div class="ss-empty">
        <span class="ss-empty__i"><v-icon size="26">mdi-storefront-outline</v-icon></span>
        <b>{{ $t("settings_shell.offer.off_title") }}</b>
        <p>{{ $t("settings_shell.offer.off_text") }}</p>
        <button type="button" class="ui-btn ui-btn--primary" @click="ctl.toggle('lice_bez_ugovora')">
          {{ $t("settings_shell.offer.off_button") }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
/** Gosti isključeni: objašnjenje i dugme za uključivanje (postojeće vrijednosti se čuvaju). */
export default {
  name: "SetGuestOff",
  inject: { ctl: "settingsCtl" },
};
</script>
